<div
  data-testid="add-roles-dialog-container"
  class="add-roles-dialog p-4 flex flex-col gap-4 w-full overflow-x-hidden max-w-full"
>
  <div class="flex flex-col gap-2">
    <label class="text-sm font-medium text-gray-700" for="add-roles-search">
      {{ "configuration.job_role_mapping.dialog.search_roles" | translate }}
    </label>
    <input
      id="add-roles-search"
      data-testid="add-roles-dialog-search"
      type="text"
      pInputText
      class="w-full"
      [(ngModel)]="searchTerm"
      (input)="onSearch()"
      [placeholder]="
        'configuration.job_role_mapping.dialog.search_roles_placeholder'
          | translate
      "
    />
  </div>

  <div class="roles-table-section flex-1 min-h-0 w-full overflow-x-hidden min-w-0">
    <app-data-table
      data-testid="add-roles-dialog-table"
      [dataSource]="filteredRoles()"
      [columns]="columns"
      [loading]="loading()"
      [hasCheckColumn]="true"
      [selection]="selectedRoles"
      [isRowDisabledFn]="isRoleDisabled"
      [isRowSelectedFn]="isRoleSelected"
      [scrollHeight]="'320px'"
      [showPaginator]="false"
      [tableStyle]="{ width: '100%', minWidth: '0', tableLayout: 'fixed' }"
      (selectionChange)="onSelectionChange($event)"
      class="w-full"
    >
    </app-data-table>
  </div>

  <div
    class="flex items-center justify-between gap-3 pt-4 border-t border-gray-200"
  >
    <span
      data-testid="add-roles-dialog-selected-count"
      class="text-sm text-gray-500"
    >
      {{
        "configuration.job_role_mapping.dialog.selected_count"
          | translate: { count: selectedRoles.length }
      }}
    </span>
    <div class="flex gap-3">
      <app-button
        [testId]="'add-roles-dialog-cancel-btn'"
        [label]="'common.actions.cancel' | translate"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
      ></app-button>
      <app-button
        [testId]="'add-roles-dialog-confirm-btn'"
        [label]="confirmLabel()"
        type="info"
        [disabled]="!canConfirm()"
        (emitOnClick)="onConfirm()"
      ></app-button>
    </div>
  </div>
</div>
